import React, { useEffect } from 'react';
import { I_DirectionList } from '@Redux/search/interfaces';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { LightBox } from '@lion-design/core';
import Title from './subComponents/Title';
import GroupList from './subComponents/GroupList';
import styles from './styles.module.scss';
import 'normalize.css';

interface I_groupData {
    NormGroupID: string;
    GroupID: string;
    GoDate: string;
    DirectionList: Array<I_DirectionList>;
}

interface I_Props {
    groupData: I_groupData;
    open: boolean;
    ToggleLightBox: (isOpen: boolean) => void;
    storyData?: {
        url: string;
    };
}

const ResultListFlight: React.FC<I_Props> = ({ open, ToggleLightBox, groupData }) => {

    // rwd 時,如果提醒視窗高度超出螢幕高度,會自動改成內部內容可滑動
    const isMobile = useMediaQuery({
        query: '(max-width: 980px)',
    });
    useEffect(() => {
        return () => {
            const resultListFlight = document.querySelector<HTMLDivElement>('.resultList_flight');
            const modelContent = resultListFlight?.querySelector<HTMLDivElement>('.modal-content');
            if (modelContent && isMobile) {
                const height = modelContent.offsetHeight;
                if (height > window.innerHeight * 0.9) {
                    modelContent.style.height = '90vh';
                    modelContent.style.overflowY = 'scroll';
                } else {
                    modelContent.style.height = 'auto';
                    modelContent.style.overflowY = 'hidden';
                }
            }
        };
    }, [open, isMobile]);

    return (
        <LightBox
            open={open}
            ToggleLightBox={ToggleLightBox}
            className={cN(styles.container, 'resultList_flight')}
        >
            <Title />
            {groupData && <GroupList GroupList={groupData} />}
        </LightBox>
    );
};

export default ResultListFlight;
